import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'Components';
import './Strip.css';

const Strip = (props) => {
  const inc = () => ((props.index === props.keys.length - 1) ? 0 : props.index + 1);
  const dec = () => ((props.index === 0) ? props.keys.length - 1 : props.index - 1);

  return (
    <div className="strip">
      <Button onClick={() => props.onClick(dec())}>
        {!(props.index === 0) && <i className="material-icons">chevron_left</i>}
      </Button>
      <span>{props.keys[props.index]}</span>
      <Button onClick={() => props.onClick(inc())}>
        { !((props.keys.length - 1) === props.index) && <i className="material-icons">chevron_right</i>}
      </Button>
    </div>);
};

Strip.propTypes = {
  keys: PropTypes.arrayOf(PropTypes.string),
  onClick: PropTypes.func,
  index: PropTypes.number,
};

Strip.defaultProps = {
  index: 0,
};

export default Strip;



// WEBPACK FOOTER //
// ./src/components/Strip/Strip.jsx